import React from "react";
import "./ReleaseNewsOverlay.css";

export default function ReleaseNewsOverlay({ version, notes, onClose }) {
  return (
    <div className="release-news-overlay">
      <div className="release-news-modal">
        <h2>Neues Release: {version}</h2>
        <div className="release-news-notes" dangerouslySetInnerHTML={{ __html: notes }} />
        <button className="release-news-close" onClick={onClose}>Schließen</button>
      </div>
    </div>
  );
}
